module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.eot
// module id = 9
// module chunks = 0